import React from "react";
import { useSelector } from "react-redux";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { twMerge } from "tailwind-merge";


const AlertBanner = () => {
    const alert = useSelector(state => state.loginForm.alert);
    const linkText = alert.sideText ? alert.sideText : "";

    const iconMap = {
        error: <ErrorIcon className="relative" />,
        info: <InfoIcon className="relative" />,
        warning: <WarningIcon className="relative" />,
        success: <CheckCircleIcon className="relative" />
    };

    const classMap = {
        error: "bg-error-100 border-error-100 text-error-700",
        info: "bg-blue-100 border-info-100 text-info-700",
        warning: "bg-warning-100 border-warning-100 text-warning-700",
        success: "bg-success-100 border-success-100 text-success-700",
    };

    return (
        <header id="alertBanner" className={twMerge("flex shrink-0 min-h-16 max-h-32 overflow-auto min-w-full bg-error-100 border border-error-100 text-error-700 pr-5 py-4 sm:px-20 xs:px-10", classMap[alert.icon] ?? classMap["info"])}>
            <div className="flex items-center min-h-full min-w-full">
                {iconMap[alert.icon] ?? iconMap["info"]} <span className="pl-2">{alert.headingTitle}</span>
                <div className="grow">&nbsp;</div>
                <span id="bannerMessage" className="pl-2">{alert.message}</span>
                <div className="grow">&nbsp;</div>
                {alert.sideLink && linkText ? (
                    <span className="pl-2 underline">
                        <a
                            href={alert.sideLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={linkText}
                        >
                            {linkText}
                        </a>
                    </span>
                ) : null}
            </div>
        </header>
    );
};

export default AlertBanner;